import styled from 'styled-components';

export const RenderingWrapper = styled.div`
  background-color: #ffffff;
  padding: 0px;
  margin: 0px;
`;
